
const listQuery = {
  state: {
    serviceManQuery: {},
  },

  mutations: {
    SET_SERVICEMANQUERY: (state, query) => {
      state.serviceManQuery = query
    },
  },

  actions: {
    
  }
}

export default listQuery
